import { transition } from '@helpers/animate';
import borderRadius from '@helpers/borderRadius';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { contentStyles, displayStyles, link } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.div `
  --cardBgColor: ${brand.orange._100};
  --cardBorderColour: transparent;
  --cardBorderColorHover: ${brand.orange.base};
  position: relative;
  padding: 20px 16px 24px;
  margin: 0 calc(var(--sitePadding) * -1);

  @media ${from(Device.TabletSmall)} {
    padding: ${fluid(40, 56)} ${fluid(16, 40)} ${fluid(24, 40)};
    margin: 0;
    overflow: hidden;
  }

  &::before {
    ${transition('border-color')};

    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - calc(var(--sitePadding) * 2));
    height: 100%;
    background-color: var(--cardBgColor);
    border-radius: ${fluid(borderRadius.xs, borderRadius.sm)};
    box-sizing: border-box;

    @media ${from(Device.TabletSmall)} {
      left: 0;
      transform: none;
      width: 100%;
      border: 3px solid transparent;
    }
  }

  &:nth-child(4n-3) {
    --cardBgColor: ${brand.orange._100};
    --cardBorderColorHover: ${brand.orange.base};
  }

  &:nth-child(4n-2) {
    --cardBgColor: ${brand.red._100};
    --cardBorderColorHover: ${brand.red.base};
  }

  &:nth-child(4n-1) {
    --cardBgColor: ${brand.teal._100};
    --cardBorderColorHover: ${brand.teal.base};
  }

  &:nth-child(4n) {
    --cardBgColor: ${brand.validation.success._100};
    --cardBorderColorHover: ${brand.validation.success._300};
  }

  @media (hover: hover) {
    &:hover {
      &::before {
        border-color: var(--cardBorderColorHover);
      }
    }
  }
`;
const OverlayLink = styled.a `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;
const Content = styled.div `
  color: ${brand.global.black};
  padding-left: 16px;
  padding-right: 80px;

  @media ${from(Device.TabletSmall)} {
    padding-left: 0;
    padding-right: 200px;
  }

`;
const Heading = styled.span `
  ${displayStyles};

  position: relative;
  display: block;
  margin-bottom: ${fluid(12, 20)};
  font-size: 20px;
  line-height: 24px;

  @media ${from(Device.TabletSmall)} {
    font-size: 28px;
    line-height: 28px;
  }
`;
const Summary = styled.div `
  ${contentStyles};

  position: relative;

  p,
  li {
    font-size: ${fluid(14, 16)};
    line-height: ${fluid(22, 26)};
  }
`;
const FakeLink = styled.div `
  ${link};

  --iconColor: ${brand.orange.base};
  ${fonts.aptos.extraBold};
  position: relative;
  display: inline-flex;
  align-items: center;
  column-gap: 8px;
  margin-top: ${fluid(12, 20)};
  font-size: ${fluid(14, 16)};
  line-height: ${fluid(14, 16)};

  svg {
    ${transition('transform')};
    width: 12px;
    height: 12px;
    color: var(--iconColor);

    ${Container}:hover & {
      transform: translateX(4px);
    }
  }

  ${Container}:nth-child(4n-3) & {
    --iconColor: ${brand.orange.base};
  }

  ${Container}:nth-child(4n-2) & {
    --iconColor: ${brand.red.base};
  }

  ${Container}:nth-child(4n-1) & {
    --iconColor: ${brand.teal.base};
  }

  ${Container}:nth-child(4n) & {
    --iconColor: ${brand.validation.success._300};
  }
`;
const IllustrationWrapper = styled.div `
  display: flex;
  align-items: center;
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  max-width: 80px;
  min-height: calc(100% + 16px);
  height: auto;

  @media ${from(Device.TabletSmall)} {
    right: 30px;
    max-width: 180px;
    height: 100%;
    min-height: auto;
    padding: 10px;
  }

`;
const Illustration = styled.img `
  @media ${from(Device.TabletSmall)} {
    transform-origin: 50% 50%;
    width: 100%;
    max-height: 100%;
    transform: scale(0.8);

    @media (hover: hover) {
      ${transition('transform')};

      ${Container}:hover & {
        transform: scale(1);
      }
    }
  }
`;
export const IllustratedCardStyles = {
    Container,
    Content,
    FakeLink,
    Heading,
    Illustration,
    IllustrationWrapper,
    OverlayLink,
    Summary,
};
